import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, IconButton, Typography, Snackbar, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import { POLYGON_TYPE, CLEAR_ALL_POLYGONS, DELETE_POLYGON, SET_ZONE_NAME, CAMERA_ADDED } from 'store/actions';
// import { createZones } from '../../../../../api/FM/videoPageApis';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ConfigCards from './ConfigCard';
import { AnimatePresence, motion } from 'framer-motion';
import axios from 'axios';

// Define colors for all polygon types
export const polygonColors = {
  zones: '#535BAC'
};

// Predefined colors for random assignment
const colorPalette = [
  // Vibrant primary and secondary colors
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FF00FF',
  '#00FFFF',
  '#FFFF00',
  // Bright warm colors
  '#FF4500',
  '#FF6B00',
  '#FF1493',
  '#FF4D4D',
  '#FFA500',
  '#FF69B4',
  // Bright cool colors
  '#00FF7F',
  '#00CED1',
  '#1E90FF',
  '#4169E1',
  '#7B68EE',
  '#9370DB',
  // Rich jewel tones
  '#FF1744',
  '#D500F9',
  '#651FFF',
  '#3D5AFE',
  '#00B0FF',
  '#00E5FF',
  '#1DE9B6',
  '#76FF03',
  '#C6FF00',
  '#FFEA00',
  '#FFC400',
  '#FF9100'
];

const MiddleController = ({ handleCloseAnnotate, deviceName, cameraAddress }) => {
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('error');
  const [selectedService, setSelectedService] = useState(null);
  const [annotatedZones, setAnnotatedZones] = useState({});
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [savedZoneIds, setSavedZoneIds] = useState({});
  // Changed from single service ID to array of service IDs
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);

  const dispatch = useDispatch();
  const polygonData = useSelector((state) => state.cameraReducer.polygonData);
  const zoneNames = useSelector((state) => state.cameraReducer.zoneNames);
  const zoneColors = useSelector((state) => state.cameraReducer.zoneColors);
  console.log('device', deviceName);
  console.log('adde', cameraAddress);
  const store_id = JSON.parse(localStorage.getItem('store_id'));
  console.log("fvcf", store_id)
const source = JSON.parse(localStorage.getItem('source'));

  useEffect(() => {
    if (polygonData.zones && zoneNames.length > 0) {
      const initialAnnotatedZones = {};

      zoneNames.forEach((zoneName) => {
        if (polygonData.zones[zoneName] && polygonData.zones[zoneName].length > 0) {
          const serviceName = zoneName.split('_')[0];

          if (!initialAnnotatedZones[serviceName]) {
            initialAnnotatedZones[serviceName] = [];
          }

          initialAnnotatedZones[serviceName].push(zoneName);
        }
      });

      setAnnotatedZones(initialAnnotatedZones);
    }
  }, [polygonData.zones, zoneNames]);

  const getRandomColor = () => {
    const usedColors = new Set(Object.values(zoneColors || {}));

    // Filter out colors that are already in use
    const availableColors = colorPalette.filter((color) => !usedColors.has(color));

    // If all colors are used, return a random color from the full palette
    if (availableColors.length === 0) {
      return colorPalette[Math.floor(Math.random() * colorPalette.length)];
    }

    // Return a random color from the available colors
    return availableColors[Math.floor(Math.random() * availableColors.length)];
  };

  const handleDeletePolygon = (type, zoneName) => {
    // Extract service name from zoneName (assuming format: ServiceName_ZoneName)
    const serviceName = zoneName.split('_')[0];

    // Remove the zone from annotatedZones
    setAnnotatedZones((prev) => {
      const updated = { ...prev };
      if (updated[serviceName]) {
        updated[serviceName] = updated[serviceName].filter((name) => name !== zoneName);
        if (updated[serviceName].length === 0) {
          delete updated[serviceName];
        }
      }
      return updated;
    });

    // Find the index of the zone in zoneNames array
    const index = zoneNames.indexOf(zoneName);
    if (index !== -1) {
      dispatch({
        type: DELETE_POLYGON,
        payload: {
          type,
          index
        }
      });
    }
  };

  const handleClearAll = () => {
    // Clear annotatedZones state
    setAnnotatedZones({});
    // Clear selected service IDs
    setSelectedServiceIds([]);
    // Clear selected service
    setSelectedService(null);

    // Dispatch clear all polygons action
    dispatch({ type: CLEAR_ALL_POLYGONS });
  };

  const handleClearServiceZones = (serviceName) => {
    if (!serviceName) return;

    // Get all zone names for this service
    const serviceZones = zoneNames.filter((name) => name.startsWith(`${serviceName}_`));

    // Remove these zones
    serviceZones.forEach((zoneName) => {
      const index = zoneNames.indexOf(zoneName);
      if (index !== -1) {
        dispatch({
          type: DELETE_POLYGON,
          payload: {
            type: 'zones',
            index
          }
        });
      }
    });

    // Update annotatedZones state
    setAnnotatedZones((prev) => {
      const updated = { ...prev };
      delete updated[serviceName];
      return updated;
    });

    // If clearing the currently selected service, also clear the selection
    if (selectedService === serviceName) {
      setSelectedService(null);
      // Optionally clear the service IDs if you want to reset completely
      // setSelectedServiceIds([]);
    }
  };

  // Function to handle service selection with better validation
  const handleServiceSelection = (name, id) => {
    console.log('Service selected:', name, 'ID:', id, 'Type:', typeof id); // Debug log

    // Always set the selected service name
    setSelectedService(name);

    // Only add valid service IDs to the array
    if (id && id !== null && id !== undefined && id !== '' && typeof id === 'string' && id.trim().length > 0) {
      setSelectedServiceIds((prev) => {
        // Create a clean array without null/undefined values
        const cleanPrev = prev.filter(existingId =>
          existingId !== null &&
          existingId !== undefined &&
          existingId !== '' &&
          typeof existingId === 'string' &&
          existingId.trim().length > 0
        );

        // Check if ID already exists in clean array
        if (!cleanPrev.includes(id.trim())) {
          const newIds = [...cleanPrev, id.trim()];
          console.log('Updated service IDs:', newIds); // Debug log
          return newIds;
        }
        console.log('Service ID already exists in clean array:', cleanPrev); // Debug log
        return cleanPrev;
      });
    } else {
      console.log('Invalid service ID received:', id, 'Type:', typeof id); // Debug log
      // Clean up any existing invalid entries
      setSelectedServiceIds((prev) => {
        const cleanIds = prev.filter(existingId =>
          existingId !== null &&
          existingId !== undefined &&
          existingId !== '' &&
          typeof existingId === 'string' &&
          existingId.trim().length > 0
        );
        console.log('Cleaned service IDs:', cleanIds);
        return cleanIds;
      });
    }
  };

  const handleAnnotateImage = (zoneConfig) => {
    // Auto-generate a zone name based on selection
    const zoneName = `${zoneConfig.card}_${zoneConfig.zone}`.replace(/\s+/g, '_');
    const color = getRandomColor();

    // Create zone directly without dialog
    dispatch({
      type: SET_ZONE_NAME,
      payload: {
        name: zoneName,
        color
      }
    });
    dispatch({ type: POLYGON_TYPE, polygonType: 'zones' });

    // Add to annotatedZones state after successful annotation
    setAnnotatedZones((prev) => {
      const updated = { ...prev };
      if (!updated[zoneConfig.card]) {
        updated[zoneConfig.card] = [];
      }
      if (!updated[zoneConfig.card].includes(zoneName)) {
        updated[zoneConfig.card].push(zoneName);
      }
      return updated;
    });
  };

  const handleSendData = async () => {
    try {
      setLoading(true);

      const zonesData = zoneNames
        .map((zoneName) => {
          const coordinates = polygonData.zones?.[zoneName];

          if (coordinates && coordinates.length > 0) {
            const zoneData = {
              name: zoneName,
              colourHex: zoneColors[zoneName],
              roi: coordinates
            };

            if (savedZoneIds[zoneName]) {
              zoneData._id = savedZoneIds[zoneName];
            }

            return zoneData;
          }
          return null;
        })
        .filter(Boolean);

      if (zonesData.length === 0) {
        setSnackbarMessage('No valid zones to save');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
        setLoading(false);
        return;
      }

      // Filter out null, undefined, empty strings, and ensure only valid service IDs
      const validServiceIds = selectedServiceIds.filter(id =>
        id !== null &&
        id !== undefined &&
        id !== '' &&
        typeof id === 'string' &&
        id.trim().length > 0
      );

      console.log('Selected service IDs before filtering:', selectedServiceIds);
      console.log('Valid service IDs after filtering:', validServiceIds);

      const requestData = {
        device_name: deviceName,
        process_skip_frames: 5,
        camera_address: cameraAddress,
        zones: zonesData,
        default_service_ids: validServiceIds,
        store_id: store_id,
        source: source
      };

      console.log('Sending request:', requestData);

      const response = await axios.post('https://db.neophyte.live/createCamera/camera/addCamera', requestData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // For axios, check response.status instead of response.ok
      if (response.status < 200 || response.status >= 300) {
        throw new Error(`Error: ${response.status}`);
      }

      console.log('Response:', response.data);

      // For axios, the response data is directly available as response.data
      const data = response.data;

      if (data.added_zone_ids && data.added_zone_ids.length > 0) {
        const newSavedZoneIds = { ...savedZoneIds };

        data.added_zone_ids.forEach((zoneId, index) => {
          if (zonesData[index]) {
            newSavedZoneIds[zonesData[index].name] = zoneId;
          }
        });

        setSavedZoneIds(newSavedZoneIds);
      }

      handleCloseAnnotate();
      dispatch({ type: CAMERA_ADDED });
      setSnackbarMessage('Zones saved successfully');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error saving zones:', error);

      // Handle axios error response
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        setSnackbarMessage(`Error ${error.response.status}: ${error.response.data?.message || error.response.statusText}`);
      } else if (error.request) {
        // The request was made but no response was received
        setSnackbarMessage('Network error: No response from server');
      } else {
        // Something happened in setting up the request that triggered an Error
        setSnackbarMessage(error.message || 'Error saving zones');
      }

      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setIsSubmitButtonDisabled(true);

      // Get completed polygons and their names
      const zonesData = zoneNames
        .map((zoneName) => {
          const coordinates = polygonData.zones?.[zoneName];

          if (coordinates && coordinates.length > 0) {
            return {
              name: zoneName,
              colourHex: zoneColors[zoneName],
              roi: coordinates
            };
          }
          return null;
        })
        .filter(Boolean);

      if (zonesData.length === 0) {
        setSnackbarMessage('No valid zones to save');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
        setLoading(false);
        setIsSubmitButtonDisabled(false);
        return;
      }

      // Check if we have selected service IDs
      const validServiceIds = selectedServiceIds.filter(id => id !== null && id !== undefined && id !== '');
      if (!validServiceIds || validServiceIds.length === 0) {
        setSnackbarMessage('No services selected');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
        setLoading(false);
        setIsSubmitButtonDisabled(false);
        return;
      }

      // Here you would typically call the same handleSendData or create a separate submit function
      await handleSendData();

    } catch (error) {
      console.error('Error submitting camera and zones:', error);
      setSnackbarMessage(error.message || 'Error submitting camera and zones');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      setIsSubmitButtonDisabled(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  // Get zones for the currently selected service
  const getZonesForCurrentService = () => {
    if (!selectedService) return [];
    return zoneNames.filter((zoneName) => zoneName.startsWith(`${selectedService}_`));
  };

  const currentServiceZones = getZonesForCurrentService();

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            borderRadius: '10px',
            '& .MuiAlert-icon': { fontSize: '1.5rem' }
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Responsive Container */}
      <div className="flex flex-col h-[92%] mt-12 bg-gradient-to-br from-white to-gray-50 
        w-full max-w-full
        p-2 sm:p-4 lg:p-6 
        rounded-xl shadow-xl text-black
        overflow-x-hidden overflow-y-auto">
        
        <AnimatePresence mode="wait">
          <motion.header
            key={selectedService || 'default'}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            className="bg-white border-0 mt-2 sm:mt-4 shadow-lg rounded-xl 
              p-3 sm:p-4 lg:p-5 
              flex items-center justify-between 
              relative overflow-hidden
              min-h-[60px] sm:min-h-[70px] lg:min-h-[80px]"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-blue-50 opacity-40" />

            <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-gray-800 flex-1 text-center relative z-10
              px-2 sm:px-4 lg:px-0
              truncate">
              {selectedService ? `${selectedService}` : 'Services'}
            </h2>

            <div className="relative z-10 ml-2 sm:ml-4 flex-shrink-0">
              <IconButton
                className="text-gray-700 bg-white/80 backdrop-blur-sm shadow-lg 
                  p-1 sm:p-2 
                  hover:bg-red-50 transition-all duration-300
                  w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12"
                sx={{ borderRadius: '12px' }}
                onClick={handleCloseAnnotate}
              >
                <CloseRoundedIcon className="text-lg sm:text-xl lg:text-2xl transition-all duration-300 ease-in-out hover:text-red-500" />
              </IconButton>
            </div>
          </motion.header>
        </AnimatePresence>

        <main className="flex justify-center items-start flex-1 w-full h-full 
          mt-2 sm:mt-4 
          overflow-y-auto">
          <div className="w-full max-w-full">
            {/* Current Zones Panel - Show only zones for the selected service */}
            <AnimatePresence>
              {currentServiceZones.length > 0 && (
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                  className="w-full mb-4 sm:mb-6 
                    p-3 sm:p-4 lg:p-5 
                    bg-white rounded-xl shadow-lg border-0 overflow-hidden"
                >
                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between 
                    mb-3 gap-2 sm:gap-0">
                    <Typography variant="h6" className="text-gray-800 font-bold 
                      text-base sm:text-lg lg:text-xl
                      truncate max-w-full sm:max-w-none">
                      {`${selectedService} Zones`}
                    </Typography>
                    {currentServiceZones.length > 0 && (
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => handleClearServiceZones(selectedService)}
                        startIcon={<DeleteIcon className="text-sm" />}
                        disabled={loading}
                        className="text-xs sm:text-sm whitespace-nowrap
                          min-w-fit px-2 sm:px-3"
                        sx={{
                          fontSize: { xs: '0.75rem', sm: '0.875rem' },
                          padding: { xs: '4px 8px', sm: '6px 12px' }
                        }}
                      >
                        <span className="hidden sm:inline">Clear Service Zones</span>
                        <span className="sm:hidden">Clear Zones</span>
                      </Button>
                    )}
                  </div>

                  <div className="flex flex-wrap gap-2 sm:gap-3 mt-3">
                    {currentServiceZones.map((name, index) => (
                      <motion.div
                        key={name}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.2, delay: index * 0.05 }}
                        className="flex items-center bg-gradient-to-r from-gray-50 to-white 
                          px-2 sm:px-3 lg:px-4 
                          py-1 sm:py-2 
                          rounded-lg shadow-md border border-gray-100
                          min-w-0 max-w-full"
                      >
                        <div className="w-3 h-3 sm:w-4 sm:h-4 rounded-full 
                          mr-2 sm:mr-3 
                          shadow-inner flex-shrink-0" 
                          style={{ backgroundColor: zoneColors[name] }} 
                        />
                        <Typography variant="body1" className="mr-2 sm:mr-3 font-medium
                          text-xs sm:text-sm lg:text-base
                          truncate flex-1 min-w-0">
                          {name.split('_').slice(1).join('_')}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => handleDeletePolygon('zones', name)}
                          className="text-gray-400 hover:text-red-500 hover:bg-red-50 
                            transition-all duration-200 flex-shrink-0
                            w-6 h-6 sm:w-8 sm:h-8 p-1"
                        >
                          <DeleteIcon className="text-sm sm:text-base" />
                        </IconButton>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Always show the ConfigCards */}
            <div className="w-full overflow-x-hidden">
              <ConfigCards
                onAnnotateImage={handleAnnotateImage}
                onServiceSelected={handleServiceSelection}
                annotatedZones={annotatedZones}
                zoneColors={zoneColors}
                hideOtherServices={!!selectedService}
              />
            </div>
          </div>
        </main>

        {/* Responsive Footer with Action Buttons */}
        <footer className="flex flex-col sm:flex-row justify-center items-center 
          gap-2 sm:gap-4 
          mt-4 sm:mt-5 
          p-2 sm:p-0">
          <Button
            variant="outlined"
            color="error"
            onClick={handleClearAll}
            startIcon={<DeleteIcon className="text-sm sm:text-base" />}
            disabled={loading || zoneNames.length === 0}
            className="w-full sm:w-auto min-w-fit
              text-xs sm:text-sm
              px-3 sm:px-4 py-2"
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              minWidth: { xs: '100%', sm: 'auto' }
            }}
          >
            Clear All
          </Button>
          
          <Button
            variant="contained"
            onClick={handleSendData}
            disabled={loading || zoneNames.length === 0}
            className="w-full sm:w-auto min-w-fit
              text-xs sm:text-sm
              px-3 sm:px-4 py-2"
            style={{ 
              backgroundColor: loading || zoneNames.length === 0 ? 'gray' : '#44BE54', 
              color: 'white' 
            }}
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              minWidth: { xs: '100%', sm: 'auto' }
            }}
          >
            {loading ? (
              <CircularProgress size={16} className="text-white sm:mr-2" />
            ) : null}
            <span className="hidden sm:inline">Save All Polygons</span>
            <span className="sm:hidden">Save Polygons</span>
          </Button>
          
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={isSubmitButtonDisabled || loading}
            className="w-full sm:w-auto min-w-fit
              text-xs sm:text-sm
              px-3 sm:px-4 py-2"
            style={{ 
              backgroundColor: isSubmitButtonDisabled || loading ? 'gray' : '#44BE54', 
              color: 'white' 
            }}
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              minWidth: { xs: '100%', sm: 'auto' }
            }}
          >
            {loading ? (
              <CircularProgress size={16} className="text-white sm:mr-2" />
            ) : null}
            Submit
          </Button>
        </footer>
      </div>
    </>
  );
};

export default MiddleController;